<template>

</template>

<script>
export default {
  name: "ChatsPage"
}
</script>


